import styled from "styled-components/macro";
import { colorProductBlur, gridCenter } from "../../styles/globalVariables";
import { uTransitionVisiblityOnly } from "../../styles/utility";
import { ActiveProp } from "../../styles/interfaces";

const StyledModalBackground = styled.div<ActiveProp>`
  position: fixed;
  height: 100vh;
  width: 100%;
  background-color: rgb(${colorProductBlur}, 0.7);
  z-index: 100000;
  inset: 0;
  ${gridCenter}

  ${uTransitionVisiblityOnly}
`;

type Props = { isActive: boolean; children: React.ReactNode };

const ModalBackground = ({ isActive, children }: Props) => {
  return (
    <StyledModalBackground isActive={isActive}>
      {children}
    </StyledModalBackground>
  );
};

export default ModalBackground;
